import OrganizationLayout from "@/components/layout/OrganizationLayout.vue";

export const organizationRoutes = [
  {
    path: "/organization",
    component: OrganizationLayout,
    children: [
      {
        path: "contest",
        name: "ContestManage",
        component: () => import("@/views/contest/ContestManageView.vue"),
        meta: {
          analytics: {
            category: "organization",
            type: "contest_manage",
          },
        },
      },
      {
        path: "contest/:contestId/applicants",
        name: "ContestApplicants",
        component: () => import("@/views/contest/ContestApplicantsView.vue"),
        meta: {
          analytics: {
            category: "organization",
            type: "contest_applicants",
          },
        },
        props: true,
      },
    ],
  },
];
